import { createContext } from 'react';

const AuthContext = createContext();//CurrentContextData);

export default AuthContext;
